
const state = {
    // 监控列表
    monitorList: []
}

const getters = {}

const mutations = {
    updateMonitorList(state, payload) {
        state.monitorList = payload
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
